import styled from "styled-components";

export const RadioButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: .5rem;

    input[type="radio"] {
        cursor: pointer;
    }
`

export const RadioLabel = styled.label`
    font-size: .8rem;
    color: var(--dark-gray);
    font-weight: 400;
    cursor: pointer;
`